'use client';

/**
 * QueryProvider — wraps the app with a per-browser-tab TanStack Query
 * client.  Devtools are mounted only in development.
 *
 * The client is memoised across re-renders so navigation doesn't
 * invalidate in-flight fetches.
 */
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { ReactNode } from 'react';
import { useState } from 'react';

import { makeQueryClient } from './client';

export function QueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(() => makeQueryClient());

  return (
    <QueryClientProvider client={client}>
      {children}
      {process.env.NODE_ENV === 'development' ? (
        <ReactQueryDevtools buttonPosition="bottom-right" initialIsOpen={false} />
      ) : null}
    </QueryClientProvider>
  );
}
